import { secureGet } from './http-module';

const QR_URI = '/api/bff-ecommerce/private/product-qr/qualification';
let qr = undefined;

const qualification = {}

qualification.qr = () => {
  if (qr != undefined) return Promise.resolve(qr);
  return secureGet(QR_URI).then(({ data }) => {
      qr = data.qualified;
      return qr
  });
};

export default qualification